/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/lodash/fp/placeholder.js
// module id = 1095
// module chunks = 168707334958949